export default {
  title: 'Impostazioni mancia',
  form: {
    has_tips: {
      label: 'Consenti mance',
    },
    default_tip_percentage: {
      label: 'Percentuale mancia preselezionata',
      tooltip: 'Questa è la percentuale che verrà preselezionata per il cliente nella schermata di pagamento',
    },
    is_tip_hidden_on_receipt: {
      label: 'Mance non visibili sulle ricevute',
      tooltip: 'Se attivato, nasconde le mance sia sulle ricevute stampate che nella finestra info ordine',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
